
import { cn } from "@/lib/utils";
import { SidebarMenuButton } from "@/components/ui/sidebar";

interface AllCategoriesButtonProps {
  isSelected: boolean;
  onClick: () => void;
}

export const AllCategoriesButton = ({
  isSelected,
  onClick
}: AllCategoriesButtonProps) => {
  return (
    <SidebarMenuButton 
      onClick={onClick} 
      className={cn(
        "w-full transition-all duration-200 rounded-full px-3 font-medium",
        {
          "text-primary bg-primary/10": isSelected,
          "text-[#000000] hover:bg-primary/5": !isSelected
        },
        "hover:bg-primary/10 hover:text-primary"
      )}
      style={!isSelected ? { color: '#000000' } : undefined}
    >
      All Categories
    </SidebarMenuButton>
  );
};
